export {
  IllustrationWithText,
  ImageWithText,
  FrameWithText,
  ExplainerWithText,
} from './MediaWithText';
